

































































































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  SelectedInstrument,
  InstrumentStatus,
  DrivewealthAccountManagementType,
  DrivewealthAccountSummary
} from "@/shared/types";
import _ from "lodash";
import { Validator } from "vee-validate";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import SweepInstrumentSearch from "./SweepInstrumentSearch.vue";
import SelectListInstrumentSearch from "./SelectListInstrumentSearch.vue";
import ReviewAutomatedInvestmentFunding from "./ReviewAutomatedInvestmentFunding.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useNotifierStore } from "@/shared/store/notifier";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserStore } from "@/shared/store/user";

const ManagedStockSymbol = "RIAMANAGED";
const LeafhouseLogoUrl = "img/LH_Logo_Round_dark.png";

@Component({
  components: {
    InstrumentName,
    GenericLoadingSpinner,
    SweepInstrumentSearch,
    ReviewAutomatedInvestmentFunding,
    SelectListInstrumentSearch,
  }
})
export default class AutomatedInvestmentFundingV2 extends Vue {
  drivewealthStore = useDrivewealthStore();
  notifierStore = useNotifierStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();

  formatCurrency = formatCurrency;
  $validator: Validator;
  isReviewing = false;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ default: false })
  isPreenrollment: boolean;

  @Prop({ default: false })
  isWizard: boolean;

  @Prop({ required: false })
  accountId: number;

  detailFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2 col-md-6 col-4",
      tdClass: "pl-2 col-md-6 col-4",
      label: "Investment"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center col-md-3",
      tdClass: "text-center col-md-3"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center col-md-3 col-5",
      tdClass: "col-md-3 col-5"
    },
  ];

  allocationFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2 col-md-6",
      tdClass: "pl-2 col-md-6",
      label: "Investment"
    },
    {
      key: "icon",
      label: "",
      thClass: "text-center",
      tdClass: "text-right"
    },
    {
      key: "purchaseAllocation",
      label: "% Asset Allocation",
      thClass: "text-center col-md-3",
      tdClass: "col-md-3",
    },
    {
      key: "action",
      label: "",
      thClass: "text-center col-md-3",
      tdClass: "col-md-3",
    },
  ];

  get managedAccountInstrument (): SelectedInstrument {
    return {
      instrumentId: "managed",
      stockSymbol: ManagedStockSymbol,
      displaySymbol: this.custodianSettingsStore.isHsaBankCustodian ? "LeafHouse Managed" : null,
      companyName: "Managed Account",
      website: null,
      imageUrl: this.custodianSettingsStore.isHsaBankCustodian ? LeafhouseLogoUrl : "",
      status: InstrumentStatus.Active,
      currentPrice: 0,
      allocation: 0,
      drivewealthAccountId: this.hasManagedAccount ? this.managedAccount.drivewealthAccountId : 0,
      accountType: DrivewealthAccountManagementType.RiaManaged
    };
  }

  mounted () {
    if (this.isPreenrollment) {
      this.drivewealthSweepStore.resetSweepForPreEnrollment({ username: this.username, partnerId: this.partnerId });
    } else {
      this.drivewealthSweepStore.resetSweepState({ username: this.username, partnerId: this.partnerId });
    }

    this.drivewealthStore.loadHsaBalanceAndThreshold({ username: this.username, partnerId: this.partnerId });
    this.drivewealthWizardStore.loadExistingPreenrollment({ username: this.username, partnerId: this.partnerId });
    this.drivewealthStore.loadAccountClaims({});
    this.userStore.loadPartnerSettings();
  }

  get managedAccountList (): SelectedInstrument[] {
    return [this.managedAccountInstrument];
  }

  get isLoaded (): boolean {
    const accountId = this.hasManagedAccount ? this.managedAccount.drivewealthAccountId : this.accountId;

    if (accountId) {
      this.drivewealthStore.loadHsaBalanceAndThreshold({ accountId });
    }

    return Boolean(this.drivewealthSweepStore.sweepLoaded &&
      this.drivewealthStore.isHsaBalanceAndThresholdLoaded(accountId) &&
      this.drivewealthSweepStore.isWorkingCopyInitialized &&
      this.drivewealthWizardStore.isEnrollmentLoaded);
  }

  get hasOpenBrokeragePreenrollment (): boolean {
    return this.isPreenrollment && this.drivewealthWizardStore.accountType === DrivewealthAccountManagementType.OpenBrokerage;
  }

  get hasAdvisoryPreenrollment (): boolean {
    return this.isPreenrollment && this.drivewealthWizardStore.accountType === DrivewealthAccountManagementType.Advisory;
  }

  get hasManagedPreenrollment (): boolean {
    return this.isPreenrollment && this.drivewealthWizardStore.accountType === DrivewealthAccountManagementType.RiaManaged;
  }

  get threshold (): number {
    return this.drivewealthSweepStore.investmentThreshold;
  }

  set threshold (value: number) {
    this.drivewealthSweepStore.setInvestmentThreshold(value);
  }

  get isReviewDisabled (): boolean {
    return !(this.drivewealthSweepStore.isActive && this.drivewealthSweepStore.isNormalized) || this.errors.any() || this.userStore.partnerDisableInvestmentActivity;
  }

  get displaySkipTooltip (): boolean {
    return this.isPreenrollment || this.isWizard;
  }

  get cancelButtonCopy (): string {
    return this.isPreenrollment || this.isWizard ? "Skip" : "Cancel";
  }

  get advisoryAccountStepNumber (): number {
    if (this.hasOpenBrokerageAccount || this.hasOpenBrokeragePreenrollment) {
      return 3;
    }

    return 2;
  }

  get managedAccountStepNumber (): number {
    if (this.hasOpenBrokerageAccount && this.hasAdvisoryAccount) {
      return 4;
    } else if (this.hasOpenBrokerageAccount || this.hasAdvisoryAccount) {
      return 3;
    }

    return 2;
  }

  get percentAllocationStepNumber (): number {
    if (this.isPreenrollment) {
      return 3;
    }
    const activeAccounts = [this.hasAdvisoryAccount, this.hasOpenBrokerageAccount, this.hasManagedAccount];
    let stepNumber = 2;
    _.forEach(activeAccounts, x => {
      if (x) {
        stepNumber += 1;
      }
    });

    return stepNumber;
  }

  get advisoryAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.Advisory);

    return account;
  }

  get hasAdvisoryAccount (): boolean {
    let isAccountClaimed = true;
    if (this.advisoryAccount) {
      const accountClaim = this.drivewealthStore.accountClaims.find(
        c => c.drivewealthApiAccountId === this.advisoryAccount.drivewealthAccountId);

        if (accountClaim) {
          isAccountClaimed = accountClaim.isClaimed;
        }

    }
    return this.advisoryAccount !== undefined && isAccountClaimed;
  }

  get openBrokerageAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage);

    return account;
  }

  get hasOpenBrokerageAccount (): boolean {
    let isAccountClaimed = true;
    if (this.openBrokerageAccount) {
      const accountClaim = this.drivewealthStore.accountClaims.find(
        c => c.drivewealthApiAccountId === this.openBrokerageAccount.drivewealthAccountId);

        if (accountClaim) {
          isAccountClaimed = accountClaim.isClaimed;
        }
    }
    return this.openBrokerageAccount !== undefined && isAccountClaimed;
  }

  get managedAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.RiaManaged);

    return account;
  }

  get hasManagedAccount (): boolean {
    return this.managedAccount !== undefined;
  }

  get thresholdValidator (): { required: boolean, decimal: number, min_value_usd: number } {
    return {
      required: true,
      decimal: 2,
      min_value_usd: this.drivewealthStore.hsaInvestmentThreshold
    };
  }

  addManagedAccount (): void {
    this.drivewealthSweepStore.addSelectedInstrument(this.managedAccountInstrument);
  }

  onAllocationChanged (): void {
    this.drivewealthSweepStore.setDirty();
  }

  @Watch("isDirty")
  onIsDirtyChanged (): void {
    this.updateNavigationGuard(this.drivewealthSweepStore.isDirty);
  }

  updateNavigationGuard (confirmNavigation: boolean): void {
    const eventData = {
      confirmNavigation,
      message: "Are you sure you want to leave?  Your unsaved changes will be lost if you continue.  Click Cancel to return to the page to save your changes."
    };

    this.$emit("navigationGuardChange", eventData);
  }

  onPause (): void {
    this.drivewealthSweepStore.pauseSweep({})
      .then(_ => {
        this.notifierStore.setSuccess("Automated investing is now inactive.");
        this.updateNavigationGuard(false);
        this.$emit("complete");
      })
      .catch(err => {
        this.notifierStore.setDanger(`Failed to pause automated investing`);
      });
  }

  onResume (): void {
    this.drivewealthSweepStore.setIsActive(true);
  }

  onCancel (): void {
    this.updateNavigationGuard(false);

    if (!this.drivewealthSweepStore.sweepIsActive && this.drivewealthSweepStore.isActive &&
      this.drivewealthSweepStore.sweepWasActive) {
      // they hit the resume button, but not the Review => Accept buttons
      const eventData = {
        confirmNavigation: true,
        message: "Are you sure you want to leave?  Automated investing will not resume until it is reviewed and accepted."
      };

      this.$emit("navigationGuardChange", eventData);
    }

    this.$emit("complete");
  }

  onReview (): void {
    this.$validator.validate()
      .then(isValid => {
        if (isValid) {
          this.isReviewing = true;
          this.drivewealthSweepStore.removeInvalidAllocations();
        }
      })
      .catch();
  }

  onMakeChanges (): void {
    this.isReviewing = false;
  }

  onAfterAccept (): void {
    this.updateNavigationGuard(false);
    this.$emit("complete");
  }

  get isManagedAddButtonDisabled (): boolean {
    return this.drivewealthSweepStore.isAlreadySelected(this.managedAccountInstrument.stockSymbol);
  }

  get allocationItems () {
    if (!this.drivewealthSweepStore.selectedInstruments) {
      return [];
    }

    return this.drivewealthSweepStore.selectedInstruments.map((instrument, index) => ({
      instrument: {
        symbol: instrument.stockSymbol,
        displaySymbol: this.isHsabManagedInstrument(instrument) ? "LeafHouse Managed" : null,
        companyName: this.isHsabManagedInstrument(instrument) ? "Managed Account" : instrument.companyName,
        website: instrument.website,
        imageUrl: this.isHsabManagedInstrument(instrument) ? LeafhouseLogoUrl : instrument.imageUrl,
        drivewealthAccountId: instrument.drivewealthAccountId,
        accountType: instrument.accountType,
        isActive: instrument.status === InstrumentStatus.Active
      },
      purchaseAllocation: instrument,
      action: index,
    }));
  }

  isHsabManagedInstrument (instrument: SelectedInstrument): boolean {
    return instrument.stockSymbol === ManagedStockSymbol &&
      this.custodianSettingsStore.isHsaBankCustodian;
  }
}
